// TODO:Replat - return work items in IWorkItemFormNavigationService

/// <amd-module name="Wit/WorkItemFormExtension/IWorkItemFormNavigationService" />
/**
 * Host service for opening the work item form
 */
export interface IWorkItemFormNavigationService {
    /**
     * Opens the specified work item. The host page will display the work item in a dialog,
     * or it may update the current page view, depending on the current page.
     *
     * @param {number} workItemId The id of the work item to open
     * @param {boolean} openInNewTab (Optional) If true, opens the work item in a new tab. Default is false
     * @returns {Promise<WorkItem>} A promise that returns a work item when the work item dialog is closed. If openInNewTab is true, the promise will return null
     */
    openWorkItem(workItemId: number, openInNewTab?: boolean): Promise<void>;

    /**
     * Opens a new work item of the specified type. The host page will display the new work item in a dialog,
     * or it may update the current page view, depending on the current page.
     *
     * @param {string} workItemTypeName The name of the work item type to open
     * @param {IDictionaryStringTo<Object>} initialValues (Optional) A dictionary of any initial field values to set after opening the new work item.
     * @returns {Promise<WorkItem>} A promise that returns a work item when the work item dialog is closed. If the workitem was not saved before closing the dialog, the promise will return null
     */
    openNewWorkItem(workItemTypeName: string, initialValues?: { [key: string]: Object }): Promise<void>;
}
